import { FC, useEffect, useState } from 'react';
import FormField from '@components/form_field';
import { TAddress } from '@xeppt/xeppt-sdk/types/user';
import styles from './styles.module.scss';
import Input from '@components/common/input';
import { useFormContext, useWatch } from 'react-hook-form';
import { useLocales } from '@hooks/helpers/useLocales';
import { Country } from 'country-state-city';
import CanadaPostAutocomplete from '@components/common/canada_post_autocomplete';

interface IProps {
    name: string;
    disabled?: boolean;
    isFull?: boolean;
    isHelper?: boolean;
    label?: string;
    hidden?: boolean;
}

const FullAddress: FC<IProps> = ({
    name,
    disabled,
    isFull = true,
    label,
    isHelper = true,
    hidden
}) => {
    const { labelLocale, validationLocale, placeholderLocale } = useLocales();
    const { control } = useFormContext();
    const [isRerender, setIsRerender] = useState(true);
    const { setValue } = useFormContext();

    const value = useWatch({ name, control });

    useEffect(() => {
        setIsRerender(false);
        setTimeout(() => {
            setIsRerender(true);
        }, 0);
    }, [value]);

    return (
        <div className={styles.wrapper} style={{ display: hidden ? 'none' : 'flex' }}>
            <FormField<TAddress>
                name={name}
                renderComponent={({ onChange, errors, ...props }) => {
                    return (
                        <CanadaPostAutocomplete
                            {...props}
                            placeholder={placeholderLocale('enter_address')}
                            onChange={(val) => {
                                console.log({ val });
                                onChange(val);
                                setValue(
                                    `${name}.country`,
                                    Country.getAllCountries().find(
                                        (item) => item.isoCode === val.country
                                    )?.name || val.country
                                );
                                setIsRerender(false);
                                setTimeout(() => {
                                    setIsRerender(true);
                                }, 0);
                            }}
                            helperText={
                                !!errors?.[name]
                                    ? validationLocale('address')
                                    : isFull
                                      ? undefined
                                      : ''
                            }
                            label={label}
                            full
                            isHelper={isHelper}
                            error={!!errors?.[name]}
                            disabled={disabled}
                        />
                    );
                }}
            />
            {isFull && isRerender && (
                <div className={styles.address_wrapper}>
                    <div className={styles.row}>
                        <FormField
                            name={`${name}.address_1`}
                            renderComponent={(props) => (
                                <Input
                                    {...props}
                                    full
                                    label={labelLocale('address_1')}
                                    readOnly
                                    // readOnly={disabled}
                                    placeholder={placeholderLocale('enter_address_1')}
                                />
                            )}
                            rules={{ required: true }}
                        />
                        <FormField
                            name={`${name}.address_2`}
                            renderComponent={(props) => (
                                <Input
                                    {...props}
                                    full
                                    label={labelLocale('address_2')}
                                    readOnly
                                    placeholder={placeholderLocale('enter_address_2')}
                                    // readOnly={disabled}
                                />
                            )}
                        />
                    </div>
                    <div className={styles.row}>
                        <FormField
                            name={`${name}.country`}
                            renderComponent={(props) => (
                                <Input
                                    {...props}
                                    full
                                    label={labelLocale('country')}
                                    placeholder={placeholderLocale('enter_country')}
                                    // readOnly={disabled}
                                    readOnly
                                />
                            )}
                            rules={{ required: true }}
                        />
                        <FormField
                            name={`${name}.city`}
                            renderComponent={(props) => (
                                <Input
                                    {...props}
                                    full
                                    placeholder={placeholderLocale('enter_city')}
                                    label={labelLocale('city')}
                                    // readOnly={disabled}
                                    readOnly
                                />
                            )}
                            rules={{ required: true }}
                        />
                    </div>
                    <div className={styles.row}>
                        <FormField
                            name={`${name}.region`}
                            renderComponent={(props) => (
                                <Input
                                    {...props}
                                    full
                                    label={labelLocale('region')}
                                    placeholder={placeholderLocale('enter_region')}
                                    // readOnly={disabled}
                                    readOnly
                                />
                            )}
                            rules={{ required: true }}
                        />
                        <FormField
                            name={`${name}.zip_code`}
                            renderComponent={(props) => (
                                <Input
                                    {...props}
                                    full
                                    placeholder={placeholderLocale('enter_postal_code')}
                                    label={labelLocale('zip_code')}
                                    // readOnly={disabled}
                                    readOnly
                                />
                            )}
                            rules={{ required: true }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default FullAddress;
